module.exports = __webpack_public_path__ + "static/others-649bda2094c93753903bd1beef9c18b0.jpg";